import { get } from 'svelte/store'
import { request } from '../helpers/api'
import { isUserAdmin } from '../helpers/utils'
import { clientStore, userStore, tenantStore, locationStore, workLogStore, peopleStore } from './store'

export const getClientData = async () => {
  const clientsResponse = await request({ url: `/api/clients?tenant=${get(userStore).tenant_id}` })
  if (clientsResponse) {
    clientStore.set(clientsResponse)
  }
}

export const getTenantData = async () => {
  const tenantResponse = await request({ url: `/api/tenants?id=${get(userStore).tenant_id}` })
  if (tenantResponse) {
    tenantStore.set(tenantResponse)
  }
}

export const getWorkLogs = async (locationId) => {
  const logsResponse = await request({ url: `/api/work-logs?tenant=${get(userStore).tenant_id}&location=${locationId}` })
  if (logsResponse) {
    workLogStore.set(logsResponse)
  }
}

export const getPeopleData = async () => {
  const peopleResponse = await request({ url: `/api/users?tenant=${get(userStore).tenant_id}` })
  if (peopleResponse) {
    peopleStore.set(peopleResponse)
  }
}

export const getLocationData = async () => {
  let url = isUserAdmin(get(userStore)) ?
  `/api/locations?tenant=${get(userStore).tenant_id}` : 
  `/api/locations?user=${get(userStore)._id}`
  const locationsResponse = await request({ url })
  if (locationsResponse) {
    locationStore.set(locationsResponse)
  }
}
